import Tokenizer from '@intercom/embercom-composer/lib/html-tokenizer';
import HtmlEscaper from '@intercom/embercom-composer/lib/html-escaper';
import { decodeAttributes } from '@intercom/embercom-composer/lib/attribute-encoding';
import Em from 'ember';
export default function parseEntities(entityList, text, config) {
  text = text || '';
  let tokenizer = new Tokenizer(text, config);
  let tokens;
  Em.instrument('Composer.lib.parseEntities', null, function () {
    tokens = tokenizer.tokenize();
    addEntitiesToList(tokens, entityList, config);
  });
  return tokens.text;
}
let addEntitiesToList = function (tokens, entityList, config) {
  let opener, closer, type, options;
  while (tokens.openers.length > 0) {
    opener = tokens.openers.shift();
    closer = findFirstMatchingCloser(opener, tokens.closers);
    tokens.closers.removeObject(closer);
    type = tagToEntityType(opener);
    let href = decodeAttributes(opener.href);
    options = {
      startIndex: opener.atIndex,
      id: opener['data-id'],
      endIndex: closer ? closer.atIndex : tokens.text.length,
      href: HtmlEscaper.unescape(href),
      identifier: HtmlEscaper.unescape(opener['data-identifier']),
      //TODO: GJ: generic data- extraction
      fallback: HtmlEscaper.unescape(opener['data-fallback'])
    };
    if (type === 'attribute') {
      getAttributeData(options, config);
    }
    entityList.pushType(type, options);
  }
  entityList.mergeAll();
  entityList.removeEmptyEntities();
};
let tagToEntityType = function (tag) {
  switch (tag.name) {
    case 'b':
      return 'bold';
    case 'i':
      return 'italic';
    case 'a':
      if (/\/\/app\.intercom\.io\/apps\/([a-z0-9].+)\/admin\/[0-9]+/.test(tag.href)) {
        return 'mention';
      }
      return 'anchor';
    case 'ic-attribute':
      return 'attribute';
    case 'ic-mention':
      return 'mention';
    case 'ic-marker':
      return 'marker';
    case 'code':
      return 'code';
    default:
      throw new Error('Invalid entity type in block');
  }
};
let findFirstMatchingCloser = function (opener, closers) {
  for (let i = 0; i < closers.length; i++) {
    if (closers[i].name === opener.name && closers[i].atIndex >= opener.atIndex) {
      return closers[i];
    }
  }
};
let getAttributeData = function (options, config) {
  let attribute = config.attributes.findBy('templatable_identifier', options.identifier);
  if (attribute) {
    options.isApp = attribute.get('isApp');
    options.noFallback = attribute.get('noFallback');
    options.name = attribute.get('name');
    options.isUser = attribute.get('isUser') && !attribute.get('isUserEvent');
    options.isUserEvent = attribute.get('isUserEvent');
    options.isCompany = attribute.get('isCompany');
  }
};